import { jsx as o } from "react/jsx-runtime";
function n(r) {
  return /* @__PURE__ */ o("svg", { width: "14", height: "13", viewBox: "0 0 14 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.04185 0.956942L6.67606 0.306247C6.9446 0.0307302 7.37885 0.0307302 7.64453 0.306247L13.1982 6.00133C13.4667 6.27684 13.4667 6.72238 13.1982 6.99496L7.64453 12.693C7.37599 12.9685 6.94174 12.9685 6.67606 12.693L6.04185 12.0423C5.77045 11.7638 5.77617 11.3095 6.05328 11.0369L9.49577 7.67205H1.28524C0.90529 7.67205 0.599609 7.35842 0.599609 6.96859V6.03065C0.599609 5.64082 0.90529 5.3272 1.28524 5.3272H9.49577L6.05328 1.96233C5.77331 1.68974 5.7676 1.23542 6.04185 0.956967V0.956942Z",
      fill: "rgb(var(--background-secondary))"
    }
  ) });
}
export {
  n as ArrowRightIcon
};
